import {
    GET_ALL_JOB_CARDS,
    REMOVE_JOBCARD_BY_ID,
    UPDATE_ENABLE_FOR_JOBCARD_BY_ID,
    LOAD_ALL_COLORS_OF_JOBCARDS,
    LOAD_JOBCARD_BY_ID,
    ADD_NEW_JOBCARD,
    UPDATE_JOBCARD_BY_ID,
} from '../../actions/jobCards';
import { findByField } from '../../utils/arrObj';

function updateFieldsByData(id, data, list) {
  if (id && data && Object.keys(data).length > 0) {
    let item = findByField(id, list, 'id');

    for (let field in item) {
      for (let fieldToUpdate in data) {
        if (fieldToUpdate == field) {
          item[field] = data[fieldToUpdate];
        }
      }
    }
  }
}

export default function jobCards(state = {}, action) {
    switch (action.type) {
        case GET_ALL_JOB_CARDS:
            return Object.assign({}, state, action.payload);
        case REMOVE_JOBCARD_BY_ID:
            for (let i = 0; i < state.list.length; i++) {
                if (state.list[i].id == action.payload.id) {
                state.list.splice(i, 1);
                }
            }
            return Object.assign({}, state, action.payload);
        case UPDATE_ENABLE_FOR_JOBCARD_BY_ID:
            // TODO: Fix me
            action.payload.data.enabled = action.payload.data.enable;
            updateFieldsByData(action.payload.id, action.payload.data, state.list);
            return Object.assign({}, state, action.payload);
        case LOAD_ALL_COLORS_OF_JOBCARDS:
            return Object.assign({}, state, action.payload);
        case LOAD_JOBCARD_BY_ID:
            return Object.assign({}, state, action.payload);
        case ADD_NEW_JOBCARD:
            return Object.assign({}, state, action.payload);
        case UPDATE_JOBCARD_BY_ID:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/jobCards/index.js